import Popup from "@/components/UI/popup/Popup";
import { useLazyGetUniversalSearchQuery } from "@/store/api/userApi";
import theme from "@/theme";
import { FC, useEffect, useState } from "react";

const Mention: FC<{ mention: string }> = ({ mention }) => {
  const username = mention.slice(1);
  const [triggerSearch] = useLazyGetUniversalSearchQuery();
  const [userData, setUserData] = useState<{ uid: string; username: string } | null>(null);

  useEffect(() => {
    let isMounted = true;
    triggerSearch({ query: username, type: "users", limit: 1 })
      .unwrap()
      .then((res) => {
        const found = res?.results?.[0]?.data;
        if (isMounted && found?.username?.toLowerCase() === username.toLowerCase()) {
          setUserData({ uid: found.uid, username: found.username });
        }
      })
      .catch(() => {});
    return () => {
      isMounted = false;
    };
  }, [username]);

  if (userData) {
    return (
      <Popup uid={userData.uid} type="user">
        <span style={{ color: theme.palette.custom.mainBlue, cursor: "pointer" }}>{mention}</span>
      </Popup>
    );
  }

  return <span style={{ color: theme.palette.custom.mainBlue }}>{mention}</span>;
};
export default Mention;
